import React, { FC, ReactElement } from 'react';

import { useUserMessages } from '@atlas/core';
import { staticRoutes } from '@atlas/routing';

import LabelTranslateWithLink from 'common/I18n/Label';

import { ILinks } from '../interfaces';

import NavigationBarItem from './NavigationBarItem';

interface INavigationBarItemList {
  isExtendedBetslipNavBar?: boolean;
  links: ILinks[];
}

const NavigationBarItemList: FC<INavigationBarItemList> = ({
  isExtendedBetslipNavBar = false,
  links,
}) => {
  const userMessages = useUserMessages();
  const unreadMessagesCount = userMessages?.unreadMessagesCount;

  return links.map(
    ({
      altIcon,
      buttonStyle,
      defaultPath,
      icon,
      iconType,
      lightIcon,
      name,
      path,
      target,
      withNotification,
    }) => {
      const withNotificationToUse = isExtendedBetslipNavBar
        ? !!unreadMessagesCount && path === staticRoutes.menu
        : withNotification;
      const targetToUse = isExtendedBetslipNavBar ? target : '';
      const link = path || defaultPath || '';

      return (
        <LabelTranslateWithLink
          key={link}
          message={name}
          render={(t: string): ReactElement => (
            <NavigationBarItem
              altIcon={altIcon}
              buttonStyle={buttonStyle}
              icon={icon}
              iconType={iconType}
              label={t}
              lightIcon={lightIcon}
              link={link}
              target={targetToUse}
              withNotification={withNotificationToUse}
            />
          )}
        />
      );
    },
  );
};

export default NavigationBarItemList;
